/**
 * VG-342: Centralized Feature Flags
 *
 * PRICE_LOCKING: Temporarily disabled for logic review (2025-09-30)
 * To re-enable: Change PRICE_LOCKING constant to true
 *
 * This file provides a centralized location for feature flags that can be quickly
 * toggled on/off. All price locking checks throughout the codebase reference this
 * constant, making it easy to enable/disable the entire feature.
 */
export class FeatureFlags {
  /**
   * VG-342: Price locking for confirmed events
   *
   * When true: Products cannot be edited/deleted in confirmed events, prices are locked
   * When false: Confirmed events behave like unconfirmed events (fully editable)
   *
   * Current Status: DISABLED (false) - Under review per client request
   *
   * To re-enable after review:
   * 1. Change this constant to true
   * 2. Run: npm run build
   * 3. Verify all functionality works as expected
   *
   * Locations using this flag:
   * - app/events/edit/event-edit.component.ts (isEventConfirmed getter)
   * - app/events/view/timeline-item-edit.component.ts (isEventConfirmed getter)
   * - app/events/view/financial-summary.component.ts (isEventConfirmed getter)
   */
  static readonly PRICE_LOCKING = true;

  /**
   * Product management in itinerary timeline items
   *
   * When true: Users can add/edit/delete products within timeline items
   * When false: Product management is hidden from itinerary (use Financial Summary instead)
   *
   * Current Status: DISABLED (false) - Temporary measure to prevent duplicate entries
   *
   * To re-enable:
   * 1. Change this constant to true
   * 2. Run: npm run build
   *
   * Locations using this flag:
   * - app/events/view/timeline-item-add.component.ts
   * - app/events/view/timeline-item-edit.component.ts
   */
  static readonly ITINERARY_PRODUCT_MANAGEMENT = true;
}
